<div class="container">
  <br />
  <button (click)="onPrevious()" class="btn btn-secondary btn-lg">
    Back to TennCare Access
  </button>
  <div class="pt-2">
    <h1 class="page-title">Member Portal Login</h1>
  </div>
  <div class="container">
    <div>
      <div class="card">
        <div class="page_label p-4">
          <h2 class="section-header">TennCare Connect Account Information</h2>
          <hr />
          <p><b>Member Name:</b> {{ memberName }}</p>
          <p><b>Linked Person ID:</b> {{ personId }}</p>
          <br />
          <p>
            See below for more details about this member's TennCare Connect
            account:
          </p>
          <div class="tableHeaderColor">
            @if (this.memberDetails) {
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="this.memberDetails"
              columnMode="force"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [limit]="5"
            >
              @for (col of memberDetailsColumns; track col) {
              <ngx-datatable-column
                [name]="col.name"
                [prop]="col.prop"
              ></ngx-datatable-column>
              }
            </ngx-datatable>
            }
          </div>
          <br />
          <h2 class="section-header">Past Login Details</h2>
          <hr />
          <p>
            Use the date range below to search past login details for this
            TennCare Connect account.
          </p>
          <form [formGroup]="search">
            <div class="row g-3">
              <div class="col-md-6" style="padding-left: 90px">
                <nh-field
                  label="{{ 'BEGIN_DATE' | translate }}"
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      name="beginDate"
                      class="form-control"
                      formControlName="beginDate"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      (bsValueChange)="verifyTwoDates($event, 'beginDate')"
                      (change)="verifyTwoDates($event, 'beginDate')"
                      bsDatepicker
                      nh
                    />
                  </nh-datepicker>
                  @if (beginDateError?.isError) {
                  <div class="error-messages position-relative">
                    <span class="form-text invalid-tooltip d-block">{{
                      beginDateError.errorMessage | translate
                    }}</span>
                  </div>
                  }
                </nh-field>
              </div>
              <div class="col-md-6">
                <nh-field
                  label="{{ 'END_DATE' | translate }}"
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      name="endDate"
                      class="form-control"
                      formControlName="endDate"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      (bsValueChange)="verifyTwoDates($event, 'endDate')"
                      (change)="verifyTwoDates($event, 'endDate')"
                      bsDatepicker
                      nh
                    />
                  </nh-datepicker>
                  @if (endDateError?.isError) {
                  <div class="error-messages position-relative">
                    <span class="form-text invalid-tooltip d-block">{{
                      endDateError.errorMessage | translate
                    }}</span>
                  </div>
                  }
                </nh-field>
              </div>
            </div>
          </form>
          <br />
          <div class="row g-3">
            <div class="col-md-6" style="padding-left: 90px">
              <button
                id="continue"
                [disabled]="
                  beginDateError.isError ||
                  endDateError.isError ||
                  !this.search.controls.beginDate.value ||
                  !this.search.controls.endDate.value
                "
                class="btn btn-secondary btn-search"
                (click)="searchData(1, 'search')"
              >
                {{ "SEARCH" | translate }} <i class="fa fa-search ml-2"></i>
              </button>
            </div>
          </div>
          <br />
          @if (noLoginData) {
          <div style="text-align: center">
            <p>
              There is no past login information for the selected date range.
            </p>
          </div>
          } @if (noLoginData === false) {
          <div>
            @if (selectedDate) {
            <div style="text-align: center">
              <div>
                TennCare Connect Past Access Results<br /><strong>{{
                  selectedDate | date: "MMMMdd"
                }}</strong>
              </div>
              <br />
            </div>
            }
            <div class="calendar-wrapper">
              @if (groupedList.length > 1) {
              <button
                class="arrow-button"
                (click)="searchData(currentIdentifier - 1, 'caret')"
                [disabled]="currentIdentifier === 1"
              >
                &#9664;
              </button>
              }
              <div class="date-row" style="text-align: center">
                @for (record of chunkedDates[currentChunkIndex]; track record) {
                <button
                  class="date-button"
                  [class.active]="selectedDate === record"
                  (click)="onDateSelect(record)"
                >
                  {{ record | date: "dd" }}<br />{{ record | date: "MMMM" }}
                </button>
                }
              </div>
              @if (groupedList.length > 1) {
              <button
                class="arrow-button"
                (click)="searchData(currentIdentifier + 1, 'caret')"
                [disabled]="currentIdentifier === groupedList.length"
              >
                &#9654;
              </button>
              }
            </div>
            @if (groupedList.length > 1) {
            <div class="dots">
              @for (chunk of groupedList; track chunk; let idx = $index) {
              <span
                class="dot"
                [class.active]="idx === currentIdentifier - 1"
              ></span>
              }
            </div>
            } @if (selectedDate) {
            <div class="data-section">
              <div class="row g-3">
                <div class="col-md-6">
                  <p><strong>Access History:</strong></p>
                </div>
                <div
                  class="col-md-6"
                  style="cursor: pointer"
                  (click)="exportExcel(selectedData)"
                  style="text-align: right"
                >
                  <span
                    class="helpHover"
                    tabindex="0"
                    (keydown.enter)="exportExcel(selectedData)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22.333"
                      height="30.633"
                      viewBox="0 0 26.333 33.633"
                    >
                      <g
                        id="Group_1571"
                        data-name="Group 1571"
                        transform="translate(-12719 -2391)"
                      >
                        <path
                          id="Path_821"
                          data-name="Path 821"
                          d="M114.25,176h3.042a3.042,3.042,0,0,1,3.042,3.042v15.816a3.042,3.042,0,0,1-3.042,3.042H99.042A3.042,3.042,0,0,1,96,194.858V179.042A3.042,3.042,0,0,1,99.042,176h3.042"
                          transform="translate(12624 2225.733)"
                          fill="none"
                          stroke="#174a7c"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                        <path
                          id="Path_822"
                          data-name="Path 822"
                          d="M176,65.033l6.083,6.083,6.083-6.083M182.083,48V69.9"
                          transform="translate(12550.083 2344)"
                          fill="none"
                          stroke="#174a7c"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                    <p class="helpHovertooltip-box">Access History Export</p>
                  </span>
                </div>
              </div>
              @if (selectedData?.sessions?.length) {
              <div>
                @for (sessionData of selectedData?.sessions ; track sessionData;
                let i = $index) {
                <div>
                  <div style="display: flex" (click)="toggleExpand(i)">
                    <span style="font-size: 16px"
                      ><strong>{{ i + 1 }}.</strong>
                      {{ sessionData.sessionTime }}</span
                    >
                    <mat-icon
                      [ngClass]="{ toggle: expandedIndex === i }"
                      tabindex="0"
                      role="button"
                      (keydown.enter)="toggleExpand(i)"
                      >keyboard_arrow_down</mat-icon
                    >
                    <br /><br />
                  </div>
                  @if (expandedIndex === i) {
                  <div>
                    @for (item of sessionData?.screensViewed; track item) {
                    <span
                      style="
                        color: #3d3e40;
                        font: normal normal 400 16px 'Open Sans';
                      "
                      ><strong><span>-</span> {{ item.key }}</strong
                      ><br />
                      @if (item.value && item.value.length) {
                      <ul>
                        @for (driverFlows of item.value; track driverFlows) {
                        <li style="font-size: 15px">{{ driverFlows }}</li>
                        }
                      </ul>
                      }
                    </span>
                    }
                  </div>
                  }
                  <br />
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
          <nh-helpGlossary></nh-helpGlossary>
        </div>
      </div>
    </div>
  </div>
</div>